import { getBookingPaymentData } from "../../../app/api/getBookingPaymentData";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IPaymentResponse } from "../../../Orchestrator/Types/Index";
import { IGetBookingPaymentActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/BookingDetailActionParams";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";

class GetBookingPaymentDataAction extends BaseAction<IDefaultActionResult, IGetBookingPaymentActionParams> {

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: false,
            message: "",
            status: "fail"
        }
        try {
            const { bookingId } = this.params!
            //bookingId = "bc3f6ebe-5f6f-4eeb-9084-7f0bd34a30c8" //Voucher
            //bookingId = "90f1aa5f-6ca0-4e4a-9c21-56ef3fe00df4" //Google Pay
            if (bookingId) {
                updateRecoilState("bookingPaymentDataAtom", [])
                const response = await getBookingPaymentData(bookingId || "", false);
                if (response.answer && response.status === "ok") {
                    const paymentData: IPaymentResponse = response.answer
                    if (paymentData.items.length > 0) {
                        updateRecoilState("bookingPaymentDataAtom", paymentData)
                    } else {
                        updateRecoilState("bookingPaymentDataAtom", [])
                    }
                    actionResult.data = paymentData
                    actionResult.status = "success"
                }
            }
        } catch (error) {
            actionResult.message = "Something went wrong"
            updateRecoilState("bookingPaymentDataAtom", [])
        } finally {
            return actionResult
        }
    }
}

export const getBookingPaymentDataAction = new GetBookingPaymentDataAction();